import styled from 'styled-components';

export const FormTemplate = styled.form.attrs(({ role }) => ({
  role: role || 'form',
}))`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
`;
